// 绑定增值服务工作台(VAS Workbench) vuex
// 流程：扫描待加工容器 -> 选择增值服务类型 -> 分流到 5 个分支处理
const vasWorkbench = {
  state: {
    // 当前步骤
    vasSteps: 'vasMachineNo',
    // 工作台号
    vasMachineNo: '',
    // 页面状态：0 基础信息(扫描待加工容器/选类型)，1 分支处理中
    vasType: 'init',
    // 增值服务类型：
    //   init 未选择
    //   inStorePack   在库组套
    //   label  贴标
    vasTaskInfo: {},
    // 全屏状态
    isFullScreenVas: false,
    vasQueryInfo: {},
  },
  getters: {
    vasSteps: state => state.vasSteps,
    vasMachineNo: state => state.vasMachineNo,
    vasType: state => state.vasType,
    vasTaskInfo: state => state.vasTaskInfo,
    isFullScreenVas: state => state.isFullScreenVas,
    vasQueryInfo: state => state.vasQueryInfo,
  },
  mutations: {
    SET_VAS_QUERY_INFO(state, payload) {
      state.vasQueryInfo = payload
    },
    SET_VAS_STEPS(state, payload) {
      state.vasSteps = payload
    },
    SET_VAS_MACHINE_NO(state, payload) {
      state.vasMachineNo = payload
    },
    SET_VAS_TYPE(state, payload) {
      state.vasType = payload
    },
    SET_VAS_TASK_INFO(state, payload) {
      state.vasTaskInfo = payload
    },
    SET_IS_FULL_SCREEN_VAS(state, payload) {
      state.isFullScreenVas = payload
    },
  }
}

export default vasWorkbench